export const facebook = 'https://www.facebook.com/m.k.razvozov/'
export const twitter = 'https://twitter.com/YRazvozov'
export const instagram = 'https://www.instagram.com/yoel_razvozov/?ref=badge”&hl=uk'
export const linkedin = 'https://linkedin.com/in/yoel-razvozov-106778252'

